var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-component-item',{attrs:{"view-name":"person","breadcrumbs":_vm.breadcrumbs,"title":_vm.caption,"data-source":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }